// extracted by mini-css-extract-plugin
module.exports = {"ContentBox":"home_ContentBox__2fXBU","C_1":"home_C_1__1sMtu","C_2":"home_C_2__F_dbJ"};